import React from 'react';

import { useClient } from '../Client/Client';
import { RolesContextType } from './types';

type RolesProviderProps = {
  children: React.ReactNode;
};

export const RolesContext = React.createContext<RolesContextType>([]);

export const RolesProvider: React.FC<RolesProviderProps> = ({ children }) => {
  const [roles, setRoles] = React.useState<RolesContextType>([]);
  const { status, get } = useClient();

  React.useEffect(() => {
    if (status === 'authenticated') {
      return get<{ data: RolesContextType }>(
        '/roles?type=customer',
        ({ data }) => setRoles(data)
      );
    }
  }, [status, get]);

  return (
    <RolesContext.Provider value={roles}>{children}</RolesContext.Provider>
  );
};

export const useRoles = () => React.useContext(RolesContext);
